






















import { Component, Prop, Vue } from 'vue-property-decorator';
import Img from '../common/Img.vue';
import MainButton from '../common/MainButton.vue';

@Component({
  components: { Img, MainButton },
})
export default class PaperContentEmpty extends Vue {
  @Prop({ required: true })
  openQuestionBankModal: () => void;
}
